<template>
  <div class="page">
    <div id="action-bar">
      <input type="search" v-model="query" placeholder="Search" />
      <button @click="addClient" class="primary">Add client</button>
    </div>
    <table>
      <thead>
        <tr>
          <th></th>
          <th>Name</th>
          <th>Internal ID</th>
          <th>Created</th>
          <th>Updated</th>
          <th class="right">Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr
          @click="editClient(client.id)"
          v-for="(client, index) in clientSearch"
          :key="'client' + index"
        >
          <td><v-icon name="user" /></td>
          <td>{{ client.name }}</td>
          <td>{{ client.internalId }}</td>
          <td>{{ client.created | date }}</td>
          <td>{{ client.updated | date }}</td>
          <td class="right">
            <div class="horiz">
              <button
                class="outline thin"
                @click.stop="
                  addPanel('panel-client-tests', {
                    clientName: client.name,
                    clientId: client.id
                  })
                "
              >
                Tests
              </button>
              <button
                @click.stop="$router.push('/clients/results/' + client.id)"
                class="outline thin"
              >
                Results
              </button>
              <button
                class="icon"
                @click.stop="addPanel('panel-client-history', client.id)"
              >
                <v-icon name="chart-line" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <ClientEdit :deleteClient="deleteClient" />
    <ClientTests />
    <PanelEditTest />
    <PanelClientHistory />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ClientEdit from "./ClientEdit";
import ClientTests from "./ClientTests";
import PanelEditTest from "@/components/PanelEditTest";
import PanelClientHistory from "@/components/PanelClientHistory";

export default {
  name: "Clients",
  data() {
    return {
      query: ""
    };
  },
  components: {
    ClientEdit,
    ClientTests,
    PanelEditTest,
    PanelClientHistory
  },
  computed: {
    ...mapState("ClientsStore", ["clients"]),
    clientSearch() {
      if (this.query === "") return this.clients;
      const queryLowerCase = this.query.toLowerCase();
      return this.clients.filter(client => {
        return (
          client.name.toLowerCase().indexOf(queryLowerCase) > -1 ||
          client.internalId.toLowerCase().indexOf(queryLowerCase) > -1
        );
      });
    }
  },
  methods: {
    addClient() {
      this.addPanel("panel-client", { clientId: null });
    },
    deleteClient(client) {
      if (confirm(`Really delete client ${client.name}?`)) {
        this.$store.dispatch("ClientsStore/delete", client.id);
        this.removeAllPanels();
      }
    },
    editClient(clientId) {
      this.addPanel("panel-client", { clientId });
    }
  },
  mounted() {
    this.$store.dispatch("ClientsStore/subscribe");
  },
  beforeDestroy() {
    this.$store.dispatch("ClientsStore/unsubscribe");
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/vars";
</style>
